
import Iconify from 'src/components/Iconify';
import { Badge } from 'src/@/components/ui/badge';
import { fToNow } from 'src/utils/formatTime';

const qualificacaoConfig = {
    1: { label: 'Sem interesse', color: '#9ca3af', icon: 'mdi:snowflake', className: 'bg-gray-50 text-gray-600 border-gray-200' },
    2: { label: 'Frio', color: '#3b82f6', icon: 'mdi:snowflake', className: 'bg-blue-50 text-blue-600 border-blue-200' },
    3: { label: 'Morno', color: '#f59e0b', icon: 'mdi:fire', className: 'bg-amber-50 text-amber-700 border-amber-200' },
    4: { label: 'Esquentando', color: '#f97316', icon: 'mdi:fire', className: 'bg-orange-50 text-orange-700 border-orange-200' },
    5: { label: 'Quente', color: '#ef4444', icon: 'mdi:fire', className: 'bg-red-50 text-red-700 border-red-200' },
};

export default function NegocioCard({ card, onOpen }) {
    const qualificacao = qualificacaoConfig[card?.qualificacao] || qualificacaoConfig[1];

    return (
        <div
            onClick={onOpen}
            className="bg-white dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700 rounded-xl hover:border-violet-200 dark:hover:border-violet-600 hover:shadow-sm cursor-pointer transition-all overflow-hidden"
        >
            {/* Color accent top */}
            <div className="h-[3px] w-full" style={{ backgroundColor: qualificacao.color }} />

            <div className="p-3 space-y-2">
                {/* Header: funil + estágio */}
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1.5 flex-wrap">
                        {card?.nomeFunil && (
                            <Badge variant="outline" className="text-[10px] font-medium bg-violet-50 text-violet-700 border-violet-200">
                                <Iconify icon="ph:funnel-duotone" width={10} className="mr-0.5" />
                                {card.nomeFunil}
                            </Badge>
                        )}
                        {card?.nomeEstagio && (
                            <>
                                <Iconify icon="mdi:arrow-right-thin" width={14} className="text-gray-400" />
                                <Badge variant="outline" className="text-[10px] font-medium bg-blue-50 text-blue-700 border-blue-200">
                                    <Iconify icon="mdi:funnel-cog" width={10} className="mr-0.5" />
                                    {card.nomeEstagio}
                                </Badge>
                            </>
                        )}
                    </div>
                    <span
                        className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider"
                        style={{ backgroundColor: `${qualificacao.color}15`, color: qualificacao.color }}
                    >
                        <Iconify icon={qualificacao.icon} width={10} />
                        {qualificacao.label}
                    </span>
                </div>

                {/* Nome do lead */}
                <p className="text-[13px] font-semibold text-gray-800 dark:text-gray-200 leading-snug line-clamp-2">
                    {card?.nome || 'Sem nome'}
                </p>

                {/* Valor */}
                {card?.valor > 0 && (
                    <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-green-600 bg-green-50 px-1.5 py-0.5 rounded">
                        <Iconify icon="mdi:currency-brl" width={11} />
                        R$ {parseFloat(card.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                    </span>
                )}

                {/* Info row */}
                <div className="flex items-center gap-3">
                    {card?.data_modificacao && (
                        <span className="text-[10px] text-gray-500 dark:text-gray-400 flex items-center gap-1">
                            <Iconify icon="mdi:clock-outline" width={12} />
                            {fToNow(card.data_modificacao)}
                        </span>
                    )}
                    {card?.status && (
                        <Badge variant="outline" className="text-[10px] font-medium bg-gray-50 text-gray-600 border-gray-200">
                            {card.status}
                        </Badge>
                    )}
                </div>

                {/* Footer: contato + usuário */}
                <div className="flex items-center justify-between pt-1.5 border-t border-gray-100 dark:border-gray-700/50">
                    {card?.contato ? (
                        <div className="flex items-center gap-1.5 min-w-0">
                            <div className="w-5 h-5 rounded-full bg-violet-100 flex items-center justify-center shrink-0">
                                <Iconify icon="mdi:account" width={12} className="text-violet-600" />
                            </div>
                            <span className="text-[11px] font-medium text-gray-600 dark:text-gray-400 truncate">
                                {card.contato.nome}
                            </span>
                        </div>
                    ) : card?.nomeUsuario ? (
                        <div className="flex items-center gap-1.5 min-w-0">
                            <div className="w-5 h-5 rounded-full bg-gray-100 flex items-center justify-center shrink-0">
                                <Iconify icon="mdi:account" width={12} className="text-gray-500" />
                            </div>
                            <span className="text-[11px] font-medium text-gray-600 dark:text-gray-400 truncate">
                                {card.nomeUsuario}
                            </span>
                        </div>
                    ) : (
                        <div className="flex items-center gap-1.5">
                            <div className="w-5 h-5 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center border border-dashed border-gray-200 dark:border-gray-600">
                                <Iconify icon="mdi:account-plus-outline" width={10} className="text-gray-300 dark:text-gray-500" />
                            </div>
                            <span className="text-[10px] text-gray-400 italic">Sem contato</span>
                        </div>
                    )}
                    {card?.contato?.telefone && (
                        <span className="text-[10px] text-gray-400 flex items-center gap-0.5">
                            <Iconify icon="ic:baseline-whatsapp" width={12} className="text-green-500" />
                            {card.contato.telefone}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
}
